import gqlTagGira from 'graphql-tag';

export const CREATE_DEPENDENCY_TIMELINE_MUTATION = gqlTagGira`
    mutation CreateJWMDependencyTimelineView($input: JWMLinkItemsInput!, $fieldIdsToReturn: [String]!) {
        linkJwmItems(input: $input, fieldIdsToReturn: $fieldIdsToReturn) {
            inwardItem {
                issueId
                issueLinks(first: 10) {
                    edges {
                        node {
                            issue {
                                issueId
                            }
                            issueLinkId
                            relationName
                            direction
                        }
                    }
                }	
            }
            outwardItem {
                issueId
                issueLinks(first: 10) {
                    edges {
                        node {
                            issue {
                                issueId
                            }
                            issueLinkId
                            relationName
                            direction
                        }
                    }
                }	
            }
            success
            errors {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
`;
